export default __webpack_public_path__ + "static/media/member_background_fx.78215736.png";